
import './App.css';
import Home from './Component/Home/Home'
import ReactGa from 'react-ga'
import React,{useEffect} from 'react';


const App = () =>{

  useEffect(() =>{
      ReactGa.initialize('UA-216928563-1')
      ReactGa.pageview(window.location.pathname + window.location.search)
  },[])

  return(
      <Home />
  )
}

export default App;
